import FilterListIcon from '@mui/icons-material/FilterList';
import FiltersPage from './Filters';
import Itineraries from './Itineraries';
import Regions from './Regions';
import TitleTexts from './TitleTexts';
import { ReactComponent as CatalogIcon } from '../icons/main_menu/catalog.svg';
import { ReactComponent as TitleTextsIcon } from '../icons/main_menu/title_texts.svg';
import { ReactComponent as RegionsIcon } from '../icons/main_menu/regions.svg';
import { ReactComponent as ItinerariesIcon } from '../icons/main_menu/itineraries.svg';

const exports = {
    TitleTexts: {
        Page: TitleTexts,
        Icon: TitleTextsIcon,
    },
    Filters: {
        Page: FiltersPage,
        Icon: FilterListIcon,
    },
    Regions: {
        Page: Regions,
        Icon: RegionsIcon,
    },
    Itineraries: {
        Page: Itineraries,
        Icon: ItinerariesIcon,
    },
    Icon: CatalogIcon,
};
export default exports;
